module.exports = ".dropdown {\n  width: 95%; }\n\n.dropdown-item {\n  padding-left: 10px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  padding-right: 10px;\n  border-bottom: 1px solid #efefef; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/fields/typeahead.scss
// module id = ./src/app/shared/components/fields/typeahead.scss
// module chunks = main